import { useColorMode } from '@chakra-ui/react';
import { t } from 'i18next';
import EmptyCase from '../../../components/errors/EmptyCase.js';

export default function EmptyMyPhotoCardContent() {
  const { colorMode } = useColorMode();

  const backgroundStyles = {
    light:
      'linear-gradient(to bottom, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.3) 5%, rgba(255, 255, 255, 0.5) 20%, rgba(255, 255, 255, 0.8) 30%, rgba(255, 255, 255, 1) 55%)',
    dark: 'linear-gradient(to bottom, rgba(13, 14, 18, 0.5) 0%, rgba(13, 14, 18, 0.8) 30%, rgba(13, 14, 18, 1) 55%)'
  };

  return (
    <div
      className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none"
      style={{
        background: backgroundStyles[colorMode],
        backdropFilter: 'blur(0.5px)',
        WebkitBackdropFilter: 'blur(2px)'
      }}
    >
      <div className="flex flex-col items-center gap-[37px] w-dvw absolute top-[20%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
        {/* @ts-expect-error */}
        <EmptyCase
          emoji={'😳'}
          title={t('CollectionsHomePage.NoCollectedPhotoCards')}
          description={t('CollectionsHomePage.NoCollectedPhotoCardsDescription')}
        />
      </div>
    </div>
  );
}
